import {useEffect, useRef} from 'react';

const usePreviousRoute = value => {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};

export default usePreviousRoute;